
export default {
  name: 'BorderStyle',
  values: {
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: undefined,
    borderRadius: undefined,
    borderTopLeftRadius: undefined,
    borderTopRightRadius: undefined,
    borderBottomLeftRadius: undefined,
    borderBottomRightRadius: undefined,
    borderImage: undefined,
  },
  meta: {
    extendable: false,
  },
}
